import { Button, Modal } from "react-bootstrap";

function EventID({data,handleclose,show}) {

  return (
    <>
      <Modal
        className="Total-Revenue"
        size="md"
        centered
        show={show}
        onHide={handleclose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="align-items-center" closeButton>
          {/* <Modal.Title> Prizes  </Modal.Title> */}
          <h5 className="mr-3" style={{ fontSize: "17px" }}>
         <b>Event ID'S</b>
          </h5>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
          <div className="gscroll  col-md-12">


          {
            data?.length > 0 && data?.map((d)=>{

                if(d?.isExpired || d?.isEventFinished || d?.isEventCancelled){
                return (<span className="m-1 d-inline-block" style={{padding:' 8px 12px',background: "gainsboro"}}>{d.eventId}</span>)
                }
            })
          }
          

          </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" 
          onClick={handleclose}
          >
            close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EventID;
